import React from 'react';

import BootstrapDialog from '../lib/bootstrap-dialog';
import {invokeTerminalTxn} from '../lib/card-present/paymentus-api-invoker';

/**
 * This modal is presented during card-present (terminal) interactions. It 
 * does not allow for cancellation or normal closing based on user input to
 * the modal. The expected flow is that the terminal TXN is finalized by the 
 * user activity at the terminal (either successfully, through cancellation, 
 * or by timing out); at this point the modal is removed. 
 */
class CardPresentInteractionModal extends BootstrapDialog {
    constructor(props) {
        super(props);
        this.invokeTerminalTxn = invokeTerminalTxn.bind(this);
        this.handleCardPresentResponse = this.handleCardPresentResponse.bind(this);
    }

    componentDidMount() {
        this.invokeTerminalTxn();
    }

    handleCardPresentResponse() {
        const {state, onEndCardPresentInteraction} = this.props;
        const {setValue, setValues} = state;

        try {
            setValues((data) => {
                data.showReceipt = true;
                return data;
            })
            onEndCardPresentInteraction();
        }
        catch (ex) {
            console.log(ex.message);
            setValue('globalErrors', [{ code: 'Exception: ', message: ex.message }]);
            onEndCardPresentInteraction();
        }
    }

    render() {
        const {messages} = this.props.config;

        return (
            <BootstrapDialog
                className="modal mdb-modal fade"
                aria-labelledby="modal-terminal-interaction-title"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered modal-notify" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="modal-terminal-interaction-title">
                                {messages["card.present.terminal.txn.in.progress"]}
                            </h5>
                            <img src="images/loader-dark.gif" alt="spinner" />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12">
                                    <p>
                                        <strong>{messages["card.present.interaction.modal.text1"]}</strong>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </BootstrapDialog>
        );
    }
}

export default CardPresentInteractionModal;